import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Dialog, Button } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@mui/styles';

const DialogBuilder = ({
  title,
  content,
  acceptMsg,
  rejectMsg,
  onClose,
  onClick,
  fullScreen,
  open,
  maxWidth,
  extraActions
}) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    dialog: {
      margin: 'auto'
    }
  }));

  const DialogTitle = withStyles(useStyles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
            style={{ float: 'right' }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2)
    }
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1)
    }
  }))(MuiDialogActions);

  return (
    <Dialog
      fullWidth
      classes={{ paper: useStyles.dialog }}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        {title && (
          <Typography color="inherit" variant="h6">
            {title}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <Typography color="inherit" variant="h6">
          {content}
        </Typography>
      </DialogContent>
      <DialogActions>
        {extraActions}
        {acceptMsg && (
          <Button
            fullWidth
            size="small"
            variant="contained"
            color="primary"
            onClick={onClick}
          >
            {acceptMsg}
          </Button>
        )}
        {acceptMsg && (
          <Button
            fullWidth
            size="small"
            variant="contained"
            color="secondary"
            onClick={onClose}
          >
            {rejectMsg}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

DialogBuilder.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  acceptMsg: PropTypes.string,
  rejectMsg: PropTypes.string,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  fullScreen: PropTypes.bool,
  extraActions: PropTypes.object,
  maxWidth: PropTypes.string
};

DialogBuilder.defaultProps = {
  title: '',
  content: '',
  acceptMsg: 'Aceptar',
  rejectMsg: 'Cancelar',
  onClose: () => {},
  onClick: () => {},
  open: false,
  fullScreen: false,
  extraActions: <></>
};

export default DialogBuilder;
